<template>
  <w-icon-wrapper 
    icon-name='work-copy-contact-icon'
    :height='24'
    :width='20'
    view-box='0 0 24 24'
  >
    <g 
      id="_116_Icon_Kopieren_von_Personendaten" 
      data-name="116_Icon_Kopieren von Personendaten" 
      transform="translate(1603 -1652)"
    >
      <g 
        id="Gruppe_22780" 
        data-name="Gruppe 22780" 
        transform="translate(-1603 1652)"
      >
        <g 
          id="Gruppe_22779" 
          data-name="Gruppe 22779" 
          clip-path="url(#clip-path)"
        >
          <path 
            id="Pfad_54783" 
            data-name="Pfad 54783" 
            d="M7.82,0a4.845,4.845,0,1,0,4.84,4.85A4.84,4.84,0,0,0,7.82,0m0,7.69a2.845,2.845,0,1,1,2.84-2.84A2.838,2.838,0,0,1,7.82,7.69" 
            fill="currentColor"
          />
          <path 
            id="Pfad_54784" 
            data-name="Pfad 54784" 
            d="M16.02,8a7.978,7.978,0,0,0-5.69,2.38H3.8A3.8,3.8,0,0,0,0,14.18V24H15.64v-.01c.12.01.25.01.38.01a8,8,0,1,0,0-16M2,22V14.18a1.805,1.805,0,0,1,1.8-1.8H8.89A7.894,7.894,0,0,0,8.02,16a7.975,7.975,0,0,0,2.71,6Zm14.02,0a2.358,2.358,0,0,1-.38-.02,5.8,5.8,0,0,1-2-.47A6,6,0,0,1,10.02,16a5.883,5.883,0,0,1,1.23-3.62,5.636,5.636,0,0,1,2.04-1.71A5.834,5.834,0,0,1,16.02,10a6,6,0,1,1,0,12" 
            fill="currentColor"
          />
          <path 
            id="Pfad_54785" 
            data-name="Pfad 54785" 
            d="M18.98,11.76H14.46a.915.915,0,0,0-.92.91v.58h-.6a.924.924,0,0,0-.92.92v5.04a.918.918,0,0,0,.92.92h4.52a.924.924,0,0,0,.92-.92v-.58h.6a.924.924,0,0,0,.92-.92V12.67a.922.922,0,0,0-.92-.91m-1.6,7.37H13.02V14.25h4.36Zm1.52-1.5h-.52V14.17a.931.931,0,0,0-.92-.92H14.54v-.49H18.9Z" 
            fill="currentColor"
          />
        </g>
      </g>
      <path 
        id="Pfad_54786" 
        data-name="Pfad 54786" 
        d="M7.82,0a4.845,4.845,0,1,0,4.84,4.85A4.84,4.84,0,0,0,7.82,0m0,7.69a2.845,2.845,0,1,1,2.84-2.84A2.838,2.838,0,0,1,7.82,7.69" 
        transform="translate(-1603 1652)" 
        fill="currentColor"
      />
      <path 
        id="Pfad_54787" 
        data-name="Pfad 54787" 
        d="M16.02,8a7.978,7.978,0,0,0-5.69,2.38H3.8A3.8,3.8,0,0,0,0,14.18V24H15.64v-.01c.12.01.25.01.38.01a8,8,0,1,0,0-16M2,22V14.18a1.805,1.805,0,0,1,1.8-1.8H8.89A7.894,7.894,0,0,0,8.02,16a7.975,7.975,0,0,0,2.71,6Zm14.02,0a2.358,2.358,0,0,1-.38-.02,5.8,5.8,0,0,1-2-.47A6,6,0,0,1,10.02,16a5.883,5.883,0,0,1,1.23-3.62,5.636,5.636,0,0,1,2.04-1.71A5.834,5.834,0,0,1,16.02,10a6,6,0,1,1,0,12" 
        transform="translate(-1603 1652)" 
        fill="currentColor"
      />
      <path 
        id="Pfad_54788" 
        data-name="Pfad 54788" 
        d="M18.98,11.76H14.46a.915.915,0,0,0-.92.91v.58h-.6a.924.924,0,0,0-.92.92v5.04a.918.918,0,0,0,.92.92h4.52a.924.924,0,0,0,.92-.92v-.58h.6a.924.924,0,0,0,.92-.92V12.67a.922.922,0,0,0-.92-.91m-1.6,7.37H13.02V14.25h4.36Zm1.52-1.5h-.52V14.17a.931.931,0,0,0-.92-.92H14.54v-.49H18.9Z" 
        transform="translate(-1603 1652)" 
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCopyContact' };
</script>
